import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
export var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);
  function ErrorBoundary() {
    _classCallCheck(this, ErrorBoundary);
    return _possibleConstructorReturn(this, _getPrototypeOf(ErrorBoundary).apply(this, arguments));
  }
  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      if (this.props.api.current) {
        this.logError(error); // Allows to trigger the Error event and all listener can run on Error

        this.props.api.current.showError({
          error: error,
          errorInfo: errorInfo
        });
      }
    }
  }, {
    key: "logError",
    value: function logError(error, errorInfo) {
      this.props.logger.error("An unexpected error occurred. Error: ".concat(error && error.message, ". "), error, errorInfo);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state;
      if (this.props.hasError || (_this$state = this.state) != null && _this$state.hasError) {
        // You can render any custom fallback UI
        return this.props.render(this.state);
      }
      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return {
        hasError: true,
        error: error
      };
    }
  }]);
  return ErrorBoundary;
}(React.Component);